import DataGrid, { Column, Lookup } from 'devextreme-react/data-grid';
import ScrollView from 'devextreme-react/scroll-view';
import { useState, useEffect } from 'react';
import AsyncCallHandler from '../../../../common/AsyncCallHandler';
import NEXUS_CONST from '../../../../common/constants';
import { KAIZENCONFIG } from '../../config';
import { alert } from 'devextreme/ui/dialog';
import Prompt from '../prompt/Prompt';

const Line = props => {
    const { category, site, app } = { ...props }
    const [refresh, setRefresh] = useState(new Date().getTime())
    const lineList = useLineList(site, refresh);
    const areaOptions = useAreaOptions(site, refresh)
    const [selectedArea, setSelectedArea] = useState("Offices")
    const cellOptions = useCellOptions(site, selectedArea)

    const setCellValueArea = (newData, value, currentRowData) => {
        newData.areaName = value
        newData.cellName = ""
        setSelectedArea(value)
    }

    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    const onRowInserted = (data) => {
        let { cellName, areaName, lineName, active } = data.data

        let lineObj = {
            "id": 0,
            "siteCode": site,
            "cellName": cellName,
            "areaName": areaName,
            "lineName": lineName,
            "active": active
        }

        let isDuplicate = lineList.data.slice(0, -1).find(ele => ele.lineName.toUpperCase() === lineName.toUpperCase()
            && ele.cellName.toUpperCase() === cellName.toUpperCase()
            && ele.areaName.toUpperCase() === areaName.toUpperCase())

        if (isDuplicate) {
            alert("Duplicate Line Details")
            setRefresh(new Date().getTime())
        } else {
            AsyncCallHandler(NEXUS_CONST.MANAGE_KAIZEN_LINE, NEXUS_CONST.POST, lineObj)
                .then(res => {
                    if (res.status === 200) {
                        alert("Line Insert Success")
                    }
                    else {
                        alert("Line Insert Failed")
                        setRefresh(new Date().getTime())
                    }
                })
        }
    }

    const onRowUpdated = (data) => {
        let { id, cellName, areaName, lineName, active } = data.data

        let lineObj = {
            "id": id,
            "siteCode": site,
            "cellName": cellName,
            "areaName": areaName,
            "lineName": lineName,
            "active": active
        }
        AsyncCallHandler(NEXUS_CONST.MANAGE_KAIZEN_LINE, NEXUS_CONST.POST, lineObj)
            .then(res => {
                if (res.status === 200) {
                    alert("Line Update Success")
                    setRefresh(new Date().getTime())
                }
                else {
                    alert("Line Update Failed")
                    setRefresh(new Date().getTime())
                }
            })
    }

    const onRowRemoved = (data) => {
        let { id } = data.data
        AsyncCallHandler(NEXUS_CONST.DELETE_KAIZEN_LINE + id, NEXUS_CONST.POST)
            .then(res => {
                if (res.status === 200) {
                    alert("Line Delete Successfully")
                    setRefresh(new Date().getTime())
                }
                else {
                    alert("Line Delete Failed")
                    setRefresh(new Date().getTime())
                }
            })
    }

    const handlers = {
        onRowInserted: onRowInserted,
        onRowUpdated: onRowUpdated,
        onRowRemoved: onRowRemoved
    }

    if (lineList.isLoading) {
        return (
            <Prompt type="loading" message="Loading Line Data" />
        )
    }

    if (lineList.isError) {
        return (
            <Prompt type="error" message="Error loading Line Data" />
        )
    }



    return (
        <ScrollView {...scrollConfig} style={{ height: "80vh" }}>
            <div className="sfinfo-section">
                <div className="component" style={{ minHeight: "230px", borderRadius: ".5rem" }}>
                    {areaOptions.data && cellOptions.data && lineList.data
                        &&
                        <DataGrid
                            dataSource={lineList.data}
                            allowColumnReordering={true}
                            showBorders={true}
                            {...KAIZENCONFIG.KAIZEN_LINE_GRID}
                            {...handlers}
                        >
                            <Column dataField="id" caption="Id" dataType="number" width="50" visible={false} allowEditing={false} />
                            <Column dataField="siteCode" caption="Site Code" width="50" visible={false} allowEditing={false} />
                            <Column dataField="lineName" caption="Line Name"
                                validationRules={[{
                                    type: "required",
                                    message: "Line name is required"
                                }]}
                            />
                            <Column dataField="areaName" caption="Area Name"
                                setCellValue={setCellValueArea}
                                validationRules={[{
                                    type: "required",
                                    message: "Area name is required"
                                }]}
                            >
                                <Lookup dataSource={areaOptions.data} />
                            </Column>

                            <Column dataField="cellName" caption="Cell Name"
                                validationRules={[{
                                    type: "required",
                                    message: "Cell name is required"
                                }]}
                            >
                                <Lookup dataSource={cellOptions.data} />
                            </Column>
                            <Column dataField="active" caption="Active"
                                validationRules={[{
                                    type: "required",
                                    message: "Active is required"
                                }]}
                            >
                                <Lookup dataSource={["Y", "N"]} />
                            </Column>
                        </DataGrid>
                    }

                </div>
            </div>
        </ScrollView>
    )
}

const useLineList = (site, refresh) => {
    const [response, setResponse] = useState({ data: null, isLoading: true, isSuccess: false, isError: false, error: null });
    useEffect(() => {
        AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_LINE_LIST + site, NEXUS_CONST.GET)
            .then(res => {
                if (res.status === 200) {
                    setResponse({ data: res.data, isLoading: false, isSuccess: true, isError: false, error: null })
                }
                else {
                    setResponse({ data: res.data, isLoading: false, isSuccess: false, isError: true, error: "Error Loading Line List" })
                }
            })
    }, [refresh])
    return response
}

const useAreaOptions = (site, refresh) => {
    const [response, setResponse] = useState({ data: null, isLoading: true, isSuccess: false, isError: false, error: null });
    useEffect(() => {
        AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_AREA + site, NEXUS_CONST.GET)
            .then(res => {
                if (res.status === 200) {
                    setResponse({ data: res.data, isLoading: false, isSuccess: true, isError: false, error: null })
                }
                else {
                    setResponse({ data: res.data, isLoading: false, isSuccess: false, isError: true, error: "Error Loading Area Options" })
                }
            })
    }, [refresh])
    return response
}

const useCellOptions = (site, selectedArea) => {
    const [response, setResponse] = useState({ data: null, isLoading: true, isSuccess: false, isError: false, error: null });
    useEffect(() => {
        AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_CELL_OPTIONS + "area=" + selectedArea + "&SiteID=" + site, NEXUS_CONST.GET)
            .then(res => {
                if (res.status === 200) {
                    let _cellOptions = res.data[0].lines
                    setResponse({ data: _cellOptions, isLoading: false, isSuccess: true, isError: false, error: null })
                }
                else {
                    setResponse({ data: res.data, isLoading: false, isSuccess: false, isError: true, error: "Error Loading Cell Options" })
                }
            })
    }, [selectedArea])
    return response
}

export default Line